import type { SVGProps } from "react";
const SenecPictogramAutostromWallbox = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M18 25C16.8954 25 16 25.8954 16 27C16 28.1046 16.8954 29 18 29C19.1046 29 20 28.1046 20 27C20 25.8954 19.1046 25 18 25Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.745 6L24 12.4064V15H18.4197L14.4197 22H12.105L11.7716 25H9C7.34315 25 6 26.3431 6 28V39C6 40.6569 7.34314 42 9 42H34C35.6569 42 37 40.6569 37 39V38H42V36H37V33H42V19H30V27C30 27.5523 30.4477 28 31 28C31.5523 28 32 27.5523 32 27V21H40V31H31C30.4477 31 30 31.4477 30 32C30 32.5523 30.4477 33 31 33H35V36H26V13.5936L36.255 8H42V6H35.745ZM19.5803 17H24V31H13.1173L13.895 24H15.5803L19.5803 17ZM20 33H24V38H35V39C35 39.5523 34.5523 40 34 40H9C8.44772 40 8 39.5523 8 39V28C8 27.4477 8.44772 27 9 27H11.5494L10.8827 33H13V38H20V33ZM15 36V33H18V36H15Z"
            fill="currentColor"
        />
        <path d="M36 22L33 27H36V30L39 25H36V22Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramAutostromWallbox;
